<div class="page-wrapper chiller-theme toggled">
  <app-sidebar></app-sidebar>
  <main class="page-content">
      <app-navbar></app-navbar>
      <div class="container-fluid p-4" style="height: calc(100vh - 56px); overflow-y: auto; overflow-x: hidden; position: relative;">
        <router-outlet></router-outlet>
        @if (rbacService.loading$ | async) {
          <app-loader-rbac></app-loader-rbac>
        }
      </div>
  </main>
</div>